<div>
	<p class="font-bold">Are you sure you want to delete {{ type }} details?</p>

	<p class="mt-2 text-sm text-center">
		This action will remove all {{ type }} details added.
	</p>

	<div class="w-full flex justify-between mt-4">
		<app-button (click)="cancel()" btn="secondary" size="small">No</app-button>
		<app-button (click)="delete()" size="small">Yes</app-button>
	</div>
</div>
